@if (isWebComponentLoaded) {
    <react-dyn-xyz-app
        theme="dark"
        (callback)="handleDynCallback($any($event))"
        (dynremote)="handleDynRemote($any($event))"
        [environmentId]="dynConfig.environmentId"
        [testNetwork]="dynConfig.testNetwork"
        [singleNetworkId]="dynConfig.singleNetworkId">
    </react-dyn-xyz-app>
}
